/*** IMPORTS FROM imports-loader ***/
var define = false;

/*** IMPORTS FROM imports-loader ***/


'use strict';

const Logger = require('../logger');
const AbstractMessageHandler = require('./abstract_message_handler');

class MessageHandlerProxy extends AbstractMessageHandler {

  get MESSAGE_EVENT() {
    return 'proxy';
  }

  handleMessage(message) {
    message.data.envelope = message.data.envelope || {};
    try {
      Logger.sendLog('proxy called', Object.assign({ event: message.data.event }, message.data.envelope));
    } catch (_) {
      // drop the log
    }

    this.window.Emarsys.integration.messageToService(
      message.data.event,
      message.data.envelope,
      message.data.integrationInstanceId);
  }

}

module.exports = MessageHandlerProxy;




/*** EXPORTS FROM exports-loader ***/



/** WEBPACK FOOTER **
 ** ./message_handler/proxy.js
 **/